// Function is debounced using cancelAnimationFrame/requestAnimationFrame functions
export function dispatchOffsetLeftOnResize(node) {
    let timeout;
    function dispatchOffsetLeft() {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(() => {
            node.dispatchEvent(new CustomEvent('offsetLeftOnResize', {
                detail: node ? node.offsetLeft : null,
            }));
        });
    }
    window.addEventListener('resize', dispatchOffsetLeft);
    // Required to dispatch once on component mount
    dispatchOffsetLeft();
    return {
        destroy() {
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }
            window.removeEventListener('resize', dispatchOffsetLeft);
        },
    };
}
